import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationAccountGroupActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/AccountGroup/AccountGroupBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationAccountGroup"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationAccountGroup"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationAccountGroupActivity)
